module.exports = __webpack_public_path__ + "img/ceshi.0b8e8422.png";